import React, { createContext, useState, useCallback, useMemo } from 'react';

// 定义函数类型
type FunctionMap = {
    [key: string]: (...args: any[]) => any;
};

// 创建 Context
export const FunctionContext = createContext<{
    setChildFunction:(fnMap: FunctionMap) => void;
    executeChildFunction: (key: string, ...args: any[]) => any;
}>({
            setChildFunction: () => {},
            executeChildFunction: () => {},
        });

// 创建 Provider
export const FunctionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [childFunctions, setChildFunctions] = useState<FunctionMap>({});

    const executeChildFunction = useCallback((key: string, ...args: any[]) => {
        if (childFunctions[key]) {
            return childFunctions[key]?.(...args);
        }
        return null;
    }, [childFunctions]);

    const contextValue = useMemo(() => ({
        setChildFunction: (fnMap: FunctionMap) => setChildFunctions((prev) => ({ ...prev, ...fnMap })),
        executeChildFunction,
    }), [executeChildFunction]);

    return (
        <FunctionContext.Provider value={contextValue}>
            {children}
        </FunctionContext.Provider>
    );
};
